import * as React from 'react';
import { DegreeQuestionState } from './states/QuestionState';
import { QuestionCard } from '../../molecules/surveys/QuestionCard';
import { observer } from 'mobx-react';
import { DegreeSelectInput } from '../../atoms/select/DegreeSelectInput';
import { NonSpBr } from '../../../../commonv3/components/atoms/layouts/br';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SpOnly } from '../../../../commonv3/components/atoms/layouts/visibility';
import './degreeQuestionCard.module.scss';
import { SurveyQuestionFormat } from "../../../../commonv3/types/surveys";

type Props = {
    questionNumber: number;
    totalQuestions: number;
    questionState: DegreeQuestionState;
    format?: SurveyQuestionFormat;
};

@observer
export class DegreeQuestionCard extends React.Component<Props> {
    render() {
        const { questionNumber, totalQuestions, questionState, format } = this.props;
        const { question, value, setValue, required, validate, errorMessage } = questionState;
        const { isSp, isNonSp } = GlobalStatesV3.viewport;
        return (
            <QuestionCard
                questionNumber={questionNumber}
                totalQuestions={totalQuestions}
                sentence={question.sentence}
                subSentence={question.sub_sentence}
                required={required}
                errorMessage={errorMessage}
                onBlur={validate}
                format={format}
            >
                <div styleName="upper">
                    <div styleName="label">
                        {isSp && <span>1 - </span>}全然<NonSpBr />
                        おすすめしない
                    </div>
                    {isNonSp && (
                        <div styleName="label">
                            非常に<br />
                            おすすめする
                        </div>
                    )}
                </div>
                <DegreeSelectInput value={value} onChange={setValue} />
                {isSp && (
                    <div styleName="lower">
                        <div styleName="label">非常におすすめする - 10</div>
                    </div>
                )}
            </QuestionCard>
        );
    }
}
